var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"header-large"}},[_c('app-logo'),_c('nav-menu'),_c('profile-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }